import { render, staticRenderFns } from "./calculators.vue?vue&type=template&id=632df680&scoped=true&"
import script from "./calculators.vue?vue&type=script&lang=js&"
export * from "./calculators.vue?vue&type=script&lang=js&"
import style0 from "./calculators.vue?vue&type=style&index=0&id=632df680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632df680",
  null
  
)

export default component.exports